import classes from './BannerHero.module.scss';
import { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';

export default function BannerHero({ data }) {
    const [mobileView, setMobileView] = useState(false);

    useEffect(() => {
        setMobileView(isMobile);
    }, []);

    return (
        <div className={`${classes.oBlockBannerHero} ${classes[`${data.theme}`]}`}>
            {mobileView ? (
                <div
                    className={classes.mBackground}
                    style={{
                        backgroundImage: `url(${data.backgroundImageMobi.url})`
                    }}
                >
                    <div className={classes.aBackground}></div>
                </div>
            ) : (
                <div
                    className={classes.mBackground}
                    style={{
                        backgroundImage: `url(${data.backgroundImageDesk.url})`
                    }}
                >
                    <div className={classes.aBackground}></div>
                </div>
            )}

            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oRow} row`}>
                    <div className={`${classes.mCopy} col`}>
                        <h1 className={`${classes.aTitle}`}>{data.title}</h1>
                        <p className={`${classes.aCopy} fnt16f`}>{data.description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
